<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>
        
        <div class="row">
            <div class="col-sm-12 form-group">
                <label for="buscacns">CPF ou CNS para Reserva</label>
                <div class="input-group">
                    <input type="text" class="form-control" placeholder="Digite o CPF ou CNS" id="buscacns" v-mask="'###############'" v-model="documento">
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" id="button-addon2" @click="refreshTokenCallMethod('censo_buscaCns', 'buscaCNS')">
                            <i class="fa fa-search" aria-hidden="true"></i> Buscar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <b-alert variant="danger" :show="errorCns != null ? true : false">
            {{errorCns}}
        </b-alert>

        <div class="bordas" v-if="cnsInternacao != null">
            <div class="row">
                <div class="col-sm-12 form-group">
                    <label>Nome</label>
                    <input class="form-control" disabled :value="cnsInternacao.dados.nomeCompleto">
                </div>
            </div>

            <div class="row">
                <div v-if="cnsInternacao.dados.cpf" class="col-sm-6 form-group d-flex flex-column justify-content-end">
                    <label>CPF</label>
                    <input class="form-control" disabled :value="cnsInternacao.dados.cpf">
                </div>
                <div v-else class="col-sm-6 form-group d-flex flex-column justify-content-end">
                    <label>CNS</label>
                    <input class="form-control" disabled :value="cnsInternacao.dados.cns">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 form-group">
                    <label>Data de Nascimento</label>
                    <input class="form-control" disabled :value="nascimento">
                </div>
                <div class="col-sm-3 form-group">
                    <label>Idade</label>
                    <input class="form-control" disabled :value="cnsInternacao.dados.idade">
                </div>
                <div class="col-sm-3 form-group">
                    <label>Sexo</label>
                    <input class="form-control" disabled :value="cnsInternacao.dados.sexo">
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 form-group">
                    <label for="data-picker">Data prevista para admissão</label>
                    <datepicker
                        v-model="dataSemFormatacao"
                        :format="formatoData"
                        :disabled="dateDisabled"
                        language="pt-br"
                        id="data-picker"
                        calendar-button
                        calendar-button-icon="fa fa-calendar"
                        >
                    </datepicker>
                    <small v-if="dataSemFormatacao == ''" class="text-danger">preenchimento obrigatório</small>
                </div>

                <div class="col-sm-6 form-group">
                    <label>Hora prevista para admissão</label>
                    <input class="form-control" type="time" v-model="hora" :disabled="!dataSemFormatacao">
                    <small v-if="hora == ''" class="text-danger">preenchimento obrigatório</small>
                </div>
            </div>

            <button :disabled="verificaTempoMinimo() == false" type="button" class="btn btn-primary mt-2" @click.stop="validaSessao('reservarLeito')">Reservar o Leito</button>
            
            <p v-if="verificaTempoMinimo() == false" class="text-danger font-weight-bold mt-2">Tempo de reserva deve ser inferior a 48h</p>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from "moment"
import { captcha } from '../../../shared/mixins/captcha'
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    props: {
        dados: Object
    },
    mixins: [
        captcha,
        validaSessao
    ],
     components: {
        Datepicker,
    },
    data() {
        return {
            dataSemFormatacao: '',
            hora: '',
            formatoData: 'dd/MM/yyyy',
            dateDisabled: {
                to: new Date(new Date().setDate(new Date().getDate()-1)),
                from: new Date(new Date().setDate(new Date().getDate()+2))
            },
            documento: '',
            cnsFixo: '',
        }
    },
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
        errorCns () {
            return this.$store.getters['consultas/getErrorCns']
        },
        cnsInternacao () {
            return this.$store.getters['consultas/getCnsInternacao']
        },
        token_captcha () {
            return this.$store.getters['sessao/getCaptcha']
        },
        nascimento () {
            if (this.cnsInternacao) return this.cnsInternacao.dados.dataNascimento.substr(8,2) + '/' + this.cnsInternacao.dados.dataNascimento.substr(5,2) + '/' +  this.cnsInternacao.dados.dataNascimento.substr(0,4)
            else return ''
        }
    },
    methods: {
        buscaCNS () {
            if (this.documento.length !== 11 && this.documento.length !== 15) return

            let tpDocumento = ''
            this.documento.length == 11 ?
                tpDocumento = 'cpf' :
                tpDocumento = 'cns'

            this.$store.dispatch('consultas/buscaCnsInternacao', { tpDocumento: tpDocumento, documento: this.documento, captcha: this.token_captcha}).then(() => {
                tpDocumento === 'cns' ?
                    this.cnsFixo = this.documento :
                    this.cnsFixo = this.cnsInternacao.dados.cns
            })
        },
        formatadata (date) {
            return moment(date).format("YYYY-MM-DD")
        },
        verificaTempoMinimo () {
            if (this.dataSemFormatacao == ' ' || this.hora == '') return false

            let dia = parseInt(moment(this.dataSemFormatacao).format("DD"))
            let mes = parseInt(moment(this.dataSemFormatacao).format("MM")) - 1
            let ano = parseInt(moment(this.dataSemFormatacao).format("YYYY"))

            let hora = parseInt(this.hora.substr(0,2))
            let min = parseInt(this.hora.substr(3,2))

            let tempo = new Date(ano, mes, dia, hora, min).getTime()
            let hoje = new Date().getTime()

            if ((tempo - hoje) > 172800000) return false
            else return true
        },
        reservarLeito () {
            if (this.dataSemFormatacao == '' || this.hora == '') return

            let datahora = this.formatadata(this.dataSemFormatacao)  + ' ' + this.hora + ':00'

            let dados = {
                codigoEnfermaria: this.dados.leitoCodigoEnfermaria,
                codigoLeito: this.dados.leitoCodigo,
                dataHoraReserva: datahora,
                cns: this.cnsFixo
            }
  
            this.$emit('reservar', dados)
        }
    }
}
</script>